import { 
    Outlet,
    Navigate     
} from "react-router"
import { useAuth } from "../context/authProvider";

function UserProtectedRoute () {
    const{session, isLoading} = useAuth()
    if (isLoading) return <div> Loading ..</div>;
    console.log('going through protected route')
    if (!session) return <Navigate to={'/'} replace/>;
    return <Outlet/>
}

export default UserProtectedRoute